/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {
    HttpClient,
    HttpEvent,
    HttpHeaders, HttpParams,
    HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { ApiEditModel } from '../model/apiEditModel';
import { ApiViewModel } from '../model/apiViewModel';
import { ApprovedMgrViewModel } from '../model/approvedMgrViewModel';
import { BPMUrlViewModel } from '../model/bPMUrlViewModel';
import { BranchsViewModel } from '../model/branchsViewModel';
import { CaseReassignResultModel } from '../model/caseReassignResultModel';
import { CompanyEditModel } from '../model/companyEditModel';
import { CompanyViewModel } from '../model/companyViewModel';
import { CountProcessRolesUsersViewModel } from '../model/countProcessRolesUsersViewModel';
import { DepartmentDataViewModel } from '../model/departmentDataViewModel';
import { DepartmentEditModel } from '../model/departmentEditModel';
import { DepartmentLevelViewModel } from '../model/departmentLevelViewModel';
import { DepartmentUserTypeSearch } from '../model/departmentUserTypeSearch';
import { DepartmentUserTypeSearchViewModel } from '../model/departmentUserTypeSearchViewModel';
import { DepartmentUserViewModel } from '../model/departmentUserViewModel';
import { DepartmentViewModel } from '../model/departmentViewModel';
import { EmailNotificationModel } from '../model/emailNotificationModel';
import { FunctionPrivilegeViewModel } from '../model/functionPrivilegeViewModel';
import { GMDepartmentViewModel } from '../model/gMDepartmentViewModel';
import { GetReassignmentListViewModel } from '../model/getReassignmentListViewModel';
import { JobTitlesViewModel } from '../model/jobTitlesViewModel';
import { MenuTreeViewModel } from '../model/menuTreeViewModel';
import { PermissionAPIEditModel } from '../model/permissionAPIEditModel';
import { PermissionAPIEditModelWithService } from '../model/permissionAPIEditModelWithService';
import { PrincipalSubstitutionViewModel } from '../model/principalSubstitutionViewModel';
import { PrivilegeCodeInfoViewModel } from '../model/privilegeCodeInfoViewModel';
import { ProcessRoleIdContainer } from '../model/processRoleIdContainer';
import { ProcessRolesUsersViewModel } from '../model/processRolesUsersViewModel';
import { ReassignmentListPagerViewModel } from '../model/reassignmentListPagerViewModel';
import { ReassignmentListViewModel } from '../model/reassignmentListViewModel';
import { RoleDataViewMode } from '../model/roleDataViewMode';
import { RoleDepartmentUserTypeSearch } from '../model/roleDepartmentUserTypeSearch';
import { RoleDepartmentUserTypeSearchViewModel } from '../model/roleDepartmentUserTypeSearchViewModel';
import { RoleSearchPrivilegeEditModel } from '../model/roleSearchPrivilegeEditModel';
import { RoleSearchPrivilegeViewModel } from '../model/roleSearchPrivilegeViewModel';
import { RoleViewModel } from '../model/roleViewModel';
import { SCCLMappingEditModel } from '../model/sCCLMappingEditModel';
import { SCCLMappingViewModel } from '../model/sCCLMappingViewModel';
import { SearchDepartmentUserConditionViewModel } from '../model/searchDepartmentUserConditionViewModel';
import { SearchDepartmentUserViewModel } from '../model/searchDepartmentUserViewModel';
import { SearchJointPrivilegeFilterModel } from '../model/searchJointPrivilegeFilterModel';
import { SearchPrivilegeDepartmentViewModel } from '../model/searchPrivilegeDepartmentViewModel';
import { SearchPrivilegeUserNoViewModel } from '../model/searchPrivilegeUserNoViewModel';
import { SearchProcessRoleIdsViewModel } from '../model/searchProcessRoleIdsViewModel';
import { SearchRoleConditionViewModel } from '../model/searchRoleConditionViewModel';
import { SearchRolePrivilegeMappingConditionViewModel } from '../model/searchRolePrivilegeMappingConditionViewModel';
import { SearchRolePrivilegeMappingViewModel } from '../model/searchRolePrivilegeMappingViewModel';
import { SearchRoleViewModel } from '../model/searchRoleViewModel';
import { SearchSalesSupportFilterModel } from '../model/searchSalesSupportFilterModel';
import { SearchSalesSupportViewModel } from '../model/searchSalesSupportViewModel';
import { SearchSystemFunctionPrivilegeConditionViewModel } from '../model/searchSystemFunctionPrivilegeConditionViewModel';
import { SearchSystemFunctionPrivilegeViewModel } from '../model/searchSystemFunctionPrivilegeViewModel';
import { SearchUserJobTitleRoleMappingConditionViewModel } from '../model/searchUserJobTitleRoleMappingConditionViewModel';
import { SearchUserJobTitleRoleMappingViewModel } from '../model/searchUserJobTitleRoleMappingViewModel';
import { SnapShotDepartmentViewModel } from '../model/snapShotDepartmentViewModel';
import { SnapShotUserProfileViewModel } from '../model/snapShotUserProfileViewModel';
import { SourceTargetRoleViewModel } from '../model/sourceTargetRoleViewModel';
import { SourceTargetUserViewModel } from '../model/sourceTargetUserViewModel';
import { SubstitutionViewModel } from '../model/substitutionViewModel';
import { SystemGroupViewModel } from '../model/systemGroupViewModel';
import { SystemViewModel } from '../model/systemViewModel';
import { UsableUserProfileViewModel } from '../model/usableUserProfileViewModel';
import { UserDataMappingViewModel } from '../model/userDataMappingViewModel';
import { UserDataProcessViewModel } from '../model/userDataProcessViewModel';
import { UserDepartmentViewMadel } from '../model/userDepartmentViewMadel';
import { UserInfoViewModel } from '../model/userInfoViewModel';
import { UserJobTitleCompanySearch } from '../model/userJobTitleCompanySearch';
import { UserJobTitleCompanySearchViewModel } from '../model/userJobTitleCompanySearchViewModel';
import { UserJobTitleInfoViewModel } from '../model/userJobTitleInfoViewModel';
import { UserJobTitlesSearchInfoViewMode } from '../model/userJobTitlesSearchInfoViewMode';
import { UserJobTitlesSearchViewMode } from '../model/userJobTitlesSearchViewMode';
import { UserListByFunctionPrivilegeViewModel } from '../model/userListByFunctionPrivilegeViewModel';
import { UserNoContainer } from '../model/userNoContainer';
import { UserPermissionViewModel } from '../model/userPermissionViewModel';
import { UserProfileEditModel } from '../model/userProfileEditModel';
import { UserProfileMasterViewModel } from '../model/userProfileMasterViewModel';
import { UserProfileSearch } from '../model/userProfileSearch';
import { UserProfileSearchViewModel } from '../model/userProfileSearchViewModel';
import { UserProfileViewModel } from '../model/userProfileViewModel';
import { UserProfilebyWorkTypeViewModel } from '../model/userProfilebyWorkTypeViewModel';
import { UserResignApplyInfoViewModel } from '../model/userResignApplyInfoViewModel';
import { UserResignApplyViewModel } from '../model/userResignApplyViewModel';
import { UserResignExecuteApiSettingViewModel } from '../model/userResignExecuteApiSettingViewModel';
import { UserResignExecuteRecordViewModel } from '../model/userResignExecuteRecordViewModel';
import { UserResignSearch } from '../model/userResignSearch';
import { UserResignSearchViewModel } from '../model/userResignSearchViewModel';
import { UserSearchPrivilegeEditModel } from '../model/userSearchPrivilegeEditModel';
import { UserTransferExecuteRecordViewModel } from '../model/userTransferExecuteRecordViewModel';
import { UserTransferSearch } from '../model/userTransferSearch';
import { UserTransferViewModel } from '../model/userTransferViewModel';
import { WorkLocationsViewModel } from '../model/workLocationsViewModel';

import { Configuration } from '../configuration';
import { ActionRecordBody } from '../model/actionRecordBody';
import { BASE_PATH } from '../variables';


@Injectable()
export class RbacService {

    protected basePath = 'http://dev-apigw.chailease.com.kh/dev-backdoor/dev/system-management';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Public] 查詢 BPM 之 ProcessDefKey 之 TaskDefKey 之 URL
     *
     * @param processDefKey Process definition key
     * @param taskDefKey Task definition key
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bPMProcessDefKeyTaskDefKeyUrlGet(processDefKey: string, taskDefKey: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<BPMUrlViewModel>;
    public bPMProcessDefKeyTaskDefKeyUrlGet(processDefKey: string, taskDefKey: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BPMUrlViewModel>>;
    public bPMProcessDefKeyTaskDefKeyUrlGet(processDefKey: string, taskDefKey: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BPMUrlViewModel>>;
    public bPMProcessDefKeyTaskDefKeyUrlGet(processDefKey: string, taskDefKey: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (processDefKey === null || processDefKey === undefined) {
            throw new Error('Required parameter processDefKey was null or undefined when calling bPMProcessDefKeyTaskDefKeyUrlGet.');
        }

        if (taskDefKey === null || taskDefKey === undefined) {
            throw new Error('Required parameter taskDefKey was null or undefined when calling bPMProcessDefKeyTaskDefKeyUrlGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BPMUrlViewModel>('get',`${this.basePath}/BPM/${encodeURIComponent(String(processDefKey))}/${encodeURIComponent(String(taskDefKey))}/Url`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 刪除API
     *
     * @param body APIID
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAPIDelete(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacAPIDelete(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacAPIDelete(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacAPIDelete(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/Rbac/API`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 依 系統代號 查詢 API
     *
     * @param systemCode
     * @param apiId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAPIGet(systemCode?: string, apiId?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ApiViewModel>>;
    public rbacAPIGet(systemCode?: string, apiId?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApiViewModel>>>;
    public rbacAPIGet(systemCode?: string, apiId?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApiViewModel>>>;
    public rbacAPIGet(systemCode?: string, apiId?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemCode !== undefined && systemCode !== null) {
            queryParameters = queryParameters.set('systemCode', <any>systemCode);
        }
        if (apiId !== undefined && apiId !== null) {
            queryParameters = queryParameters.set('apiId', <any>apiId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ApiViewModel>>('get',`${this.basePath}/Rbac/API`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立 API
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAPIPost(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<ApiViewModel>;
    public rbacAPIPost(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiViewModel>>;
    public rbacAPIPost(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiViewModel>>;
    public rbacAPIPost(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ApiViewModel>('post',`${this.basePath}/Rbac/API`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 API
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAPIPut(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacAPIPut(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacAPIPut(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacAPIPut(body?: ApiEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/API`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 登入資料
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAccountGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacAccountGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacAccountGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacAccountGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/Rbac/Account`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 處理經辦改派
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAccountOfficerReassignmentEnquiryPost(body?: GetReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<ReassignmentListPagerViewModel>;
    public rbacAccountOfficerReassignmentEnquiryPost(body?: GetReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReassignmentListPagerViewModel>>;
    public rbacAccountOfficerReassignmentEnquiryPost(body?: GetReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReassignmentListPagerViewModel>>;
    public rbacAccountOfficerReassignmentEnquiryPost(body?: GetReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ReassignmentListPagerViewModel>('post',`${this.basePath}/Rbac/AccountOfficer/Reassignment/Enquiry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 處理經辦改派
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAccountOfficerReassignmentPost(body?: ReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CaseReassignResultModel>>;
    public rbacAccountOfficerReassignmentPost(body?: ReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CaseReassignResultModel>>>;
    public rbacAccountOfficerReassignmentPost(body?: ReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CaseReassignResultModel>>>;
    public rbacAccountOfficerReassignmentPost(body?: ReassignmentListViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<CaseReassignResultModel>>('post',`${this.basePath}/Rbac/AccountOfficer/Reassignment`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 處理經辦改派 可使用的部門
     *
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacAccountOfficerUsableDepartmentGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacAccountOfficerUsableDepartmentGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacAccountOfficerUsableDepartmentGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacAccountOfficerUsableDepartmentGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/AccountOfficer/UsableDepartment`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得營業處所
     *
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacBranchsCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BranchsViewModel>>;
    public rbacBranchsCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BranchsViewModel>>>;
    public rbacBranchsCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BranchsViewModel>>>;
    public rbacBranchsCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacBranchsCompanyIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BranchsViewModel>>('get',`${this.basePath}/Rbac/Branchs/${encodeURIComponent(String(companyId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 依 部門代號 查詢 指定部門
     *
     * @param companyId 公司代號
     * @param departmentCode 部門代號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet(companyId: number, departmentCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<DepartmentViewModel>;
    public rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet(companyId: number, departmentCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DepartmentViewModel>>;
    public rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet(companyId: number, departmentCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DepartmentViewModel>>;
    public rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet(companyId: number, departmentCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet.');
        }

        if (departmentCode === null || departmentCode === undefined) {
            throw new Error('Required parameter departmentCode was null or undefined when calling rbacCompanyCompanyIdDepartmentCodeDepartmentCodeDepartmentGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DepartmentViewModel>('get',`${this.basePath}/Rbac/Company/${encodeURIComponent(String(companyId))}/DepartmentCode/${encodeURIComponent(String(departmentCode))}/Department`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定公司 或包含 所有下屬公司
     *
     * @param companyId
     * @param isSub
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCompanyCompanyIdIsSubGet(companyId: number, isSub: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CompanyViewModel>>;
    public rbacCompanyCompanyIdIsSubGet(companyId: number, isSub: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CompanyViewModel>>>;
    public rbacCompanyCompanyIdIsSubGet(companyId: number, isSub: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CompanyViewModel>>>;
    public rbacCompanyCompanyIdIsSubGet(companyId: number, isSub: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacCompanyCompanyIdIsSubGet.');
        }

        if (isSub === null || isSub === undefined) {
            throw new Error('Required parameter isSub was null or undefined when calling rbacCompanyCompanyIdIsSubGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CompanyViewModel>>('get',`${this.basePath}/Rbac/Company/${encodeURIComponent(String(companyId))}/${encodeURIComponent(String(isSub))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 所有公司
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCompanyGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CompanyViewModel>>;
    public rbacCompanyGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CompanyViewModel>>>;
    public rbacCompanyGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CompanyViewModel>>>;
    public rbacCompanyGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CompanyViewModel>>('get',`${this.basePath}/Rbac/Company`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立 公司
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCompanyPost(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacCompanyPost(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacCompanyPost(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacCompanyPost(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/Company`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 公司
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCompanyPut(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacCompanyPut(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacCompanyPut(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacCompanyPut(body?: CompanyEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/Company`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 搜尋 指定使用者代號 列表 之 共同主管
     *
     * @param body 使用者代號 列表
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param isAuthentication Authentication or Manager
     * @param filterVirtual 過濾虛擬部門
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacCosupervisorSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, isAuthentication?: boolean, filterVirtual?: boolean, observe?: 'body', reportProgress?: boolean): Observable<UserProfileViewModel>;
    public rbacCosupervisorSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, isAuthentication?: boolean, filterVirtual?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserProfileViewModel>>;
    public rbacCosupervisorSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, isAuthentication?: boolean, filterVirtual?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserProfileViewModel>>;
    public rbacCosupervisorSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, isAuthentication?: boolean, filterVirtual?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isAuthentication !== undefined && isAuthentication !== null) {
            queryParameters = queryParameters.set('isAuthentication', <any>isAuthentication);
        }
        if (filterVirtual !== undefined && filterVirtual !== null) {
            queryParameters = queryParameters.set('filterVirtual', <any>filterVirtual);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserProfileViewModel>('post',`${this.basePath}/Rbac/Cosupervisor/Search`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定公司 之 所有部門
     *
     * @param companyId 公司代號
     * @param filterDisabled 過濾未使用部門
     * @param filterMultipleRole 過濾兼職人員部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentCompanyCompanyIdGet(companyId: number, filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacDepartmentCompanyCompanyIdGet(companyId: number, filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacDepartmentCompanyCompanyIdGet(companyId: number, filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacDepartmentCompanyCompanyIdGet(companyId: number, filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacDepartmentCompanyCompanyIdGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterDisabled !== undefined && filterDisabled !== null) {
            queryParameters = queryParameters.set('filterDisabled', <any>filterDisabled);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/Department/Company/${encodeURIComponent(String(companyId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定公司 之 所有部門(未輸入公司代號)
     *
     * @param filterDisabled 過濾未使用部門
     * @param filterMultipleRole 過濾兼職人員部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentCompanyGet(filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacDepartmentCompanyGet(filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacDepartmentCompanyGet(filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacDepartmentCompanyGet(filterDisabled?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterDisabled !== undefined && filterDisabled !== null) {
            queryParameters = queryParameters.set('filterDisabled', <any>filterDisabled);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/Department/Company`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增部門、部門人員設定資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentDataPost(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<DepartmentDataViewModel>;
    public rbacDepartmentDataPost(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DepartmentDataViewModel>>;
    public rbacDepartmentDataPost(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DepartmentDataViewModel>>;
    public rbacDepartmentDataPost(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DepartmentDataViewModel>('post',`${this.basePath}/Rbac/DepartmentData`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 修改部門、部門人員設定資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentDataPut(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacDepartmentDataPut(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacDepartmentDataPut(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacDepartmentDataPut(body?: DepartmentDataViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/DepartmentData`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定部門 或包含 所有下屬部門
     *
     * @param departmentId 部門代號
     * @param isSub 包含下屬部門
     * @param filterDisabled 過濾未使用部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacDepartmentDepartmentIdIsSubGet.');
        }

        if (isSub === null || isSub === undefined) {
            throw new Error('Required parameter isSub was null or undefined when calling rbacDepartmentDepartmentIdIsSubGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterDisabled !== undefined && filterDisabled !== null) {
            queryParameters = queryParameters.set('filterDisabled', <any>filterDisabled);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/Department/${encodeURIComponent(String(departmentId))}/${encodeURIComponent(String(isSub))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得根部門與下屬部門對應關係與排序
     *
     * @param departmentcode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentLevelDepartmentcodeGet(departmentcode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentLevelViewModel>>;
    public rbacDepartmentLevelDepartmentcodeGet(departmentcode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentLevelViewModel>>>;
    public rbacDepartmentLevelDepartmentcodeGet(departmentcode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentLevelViewModel>>>;
    public rbacDepartmentLevelDepartmentcodeGet(departmentcode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentcode === null || departmentcode === undefined) {
            throw new Error('Required parameter departmentcode was null or undefined when calling rbacDepartmentLevelDepartmentcodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentLevelViewModel>>('get',`${this.basePath}/Rbac/DepartmentLevel/${encodeURIComponent(String(departmentcode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立 部門
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentPost(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacDepartmentPost(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacDepartmentPost(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacDepartmentPost(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/Department`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 部門
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentPut(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacDepartmentPut(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacDepartmentPut(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacDepartmentPut(body?: DepartmentEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/Department`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 依部門代號 取得 部門人員資料
     *
     * @param departmentId 部門代號
     * @param departmentUserType 部門人員屬性(選填)
     * @param includeDisabled 是否包含離職人員(選填)(預設不含)
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentUserDepartmentDepartmentIdGet(departmentId: number, departmentUserType?: string, includeDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentUserViewModel>>;
    public rbacDepartmentUserDepartmentDepartmentIdGet(departmentId: number, departmentUserType?: string, includeDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentUserViewModel>>>;
    public rbacDepartmentUserDepartmentDepartmentIdGet(departmentId: number, departmentUserType?: string, includeDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentUserViewModel>>>;
    public rbacDepartmentUserDepartmentDepartmentIdGet(departmentId: number, departmentUserType?: string, includeDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacDepartmentUserDepartmentDepartmentIdGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (departmentUserType !== undefined && departmentUserType !== null) {
            queryParameters = queryParameters.set('departmentUserType', <any>departmentUserType);
        }
        if (includeDisabled !== undefined && includeDisabled !== null) {
            queryParameters = queryParameters.set('includeDisabled', <any>includeDisabled);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentUserViewModel>>('get',`${this.basePath}/Rbac/DepartmentUser/Department/${encodeURIComponent(String(departmentId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得部門員工資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentUserSearchPost(body?: SearchDepartmentUserConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchDepartmentUserViewModel>;
    public rbacDepartmentUserSearchPost(body?: SearchDepartmentUserConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchDepartmentUserViewModel>>;
    public rbacDepartmentUserSearchPost(body?: SearchDepartmentUserConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchDepartmentUserViewModel>>;
    public rbacDepartmentUserSearchPost(body?: SearchDepartmentUserConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchDepartmentUserViewModel>('post',`${this.basePath}/Rbac/DepartmentUser/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢部門人員屬性
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentUserTypesSearchPost(body?: DepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<DepartmentUserTypeSearch>;
    public rbacDepartmentUserTypesSearchPost(body?: DepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DepartmentUserTypeSearch>>;
    public rbacDepartmentUserTypesSearchPost(body?: DepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DepartmentUserTypeSearch>>;
    public rbacDepartmentUserTypesSearchPost(body?: DepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DepartmentUserTypeSearch>('post',`${this.basePath}/Rbac/DepartmentUserTypes/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 使用者編號 所屬  部門
     *
     * @param userNo 使用者編號
     * @param filterVirtual
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentUserUserNoGet(userNo: string, filterVirtual?: boolean, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacDepartmentUserUserNoGet(userNo: string, filterVirtual?: boolean, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacDepartmentUserUserNoGet(userNo: string, filterVirtual?: boolean, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacDepartmentUserUserNoGet(userNo: string, filterVirtual?: boolean, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacDepartmentUserUserNoGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterVirtual !== undefined && filterVirtual !== null) {
            queryParameters = queryParameters.set('filterVirtual', <any>filterVirtual);
        }
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/Department/User/${encodeURIComponent(String(userNo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定業務類別 之 所有部門
     *
     * @param workType 業務類別
     * @param filterDisabled 過濾未使用部門
     * @param companyId 公司代號
     * @param filterMultipleRole 過濾兼職人員部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacDepartmentWorkTypeWorkTypeGet(workType: number, filterDisabled?: boolean, companyId?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentViewModel>>;
    public rbacDepartmentWorkTypeWorkTypeGet(workType: number, filterDisabled?: boolean, companyId?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentViewModel>>>;
    public rbacDepartmentWorkTypeWorkTypeGet(workType: number, filterDisabled?: boolean, companyId?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentViewModel>>>;
    public rbacDepartmentWorkTypeWorkTypeGet(workType: number, filterDisabled?: boolean, companyId?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (workType === null || workType === undefined) {
            throw new Error('Required parameter workType was null or undefined when calling rbacDepartmentWorkTypeWorkTypeGet.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterDisabled !== undefined && filterDisabled !== null) {
            queryParameters = queryParameters.set('filterDisabled', <any>filterDisabled);
        }
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentViewModel>>('get',`${this.basePath}/Rbac/Department/WorkType/${encodeURIComponent(String(workType))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定功能代碼 之 功能權代碼 之功能權資訊
     *
     * @param functionCode
     * @param privilegeCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet(functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<FunctionPrivilegeViewModel>;
    public rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet(functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FunctionPrivilegeViewModel>>;
    public rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet(functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FunctionPrivilegeViewModel>>;
    public rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet(functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (functionCode === null || functionCode === undefined) {
            throw new Error('Required parameter functionCode was null or undefined when calling rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet.');
        }

        if (privilegeCode === null || privilegeCode === undefined) {
            throw new Error('Required parameter privilegeCode was null or undefined when calling rbacFunctionPrivilegeFunctionCodePrivilegeCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FunctionPrivilegeViewModel>('get',`${this.basePath}/Rbac/FunctionPrivilege/${encodeURIComponent(String(functionCode))}/${encodeURIComponent(String(privilegeCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定員工 及 功能 之 權限資料
     *
     * @param userNo
     * @param functionCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet(userNo: string, functionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PrivilegeCodeInfoViewModel>>;
    public rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet(userNo: string, functionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PrivilegeCodeInfoViewModel>>>;
    public rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet(userNo: string, functionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PrivilegeCodeInfoViewModel>>>;
    public rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet(userNo: string, functionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet.');
        }

        if (functionCode === null || functionCode === undefined) {
            throw new Error('Required parameter functionCode was null or undefined when calling rbacFunctionPrivilegeUserNoUserNoSystemFunctionFunctionCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PrivilegeCodeInfoViewModel>>('get',`${this.basePath}/Rbac/FunctionPrivilege/UserNo/${encodeURIComponent(String(userNo))}/SystemFunction/${encodeURIComponent(String(functionCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 總經理
     *
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacGeneralManagerDeptCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<GMDepartmentViewModel>;
    public rbacGeneralManagerDeptCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GMDepartmentViewModel>>;
    public rbacGeneralManagerDeptCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GMDepartmentViewModel>>;
    public rbacGeneralManagerDeptCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacGeneralManagerDeptCompanyIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GMDepartmentViewModel>('get',`${this.basePath}/Rbac/GeneralManagerDept/${encodeURIComponent(String(companyId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢Rbac撥款處理/放行有權限的所有人員
     *
     * @param companyId
     * @param functionId
     * @param privilegeCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacGetUserListByFunctionPrivilegeGet(companyId?: number, functionId?: number, privilegeCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserListByFunctionPrivilegeViewModel>>;
    public rbacGetUserListByFunctionPrivilegeGet(companyId?: number, functionId?: number, privilegeCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserListByFunctionPrivilegeViewModel>>>;
    public rbacGetUserListByFunctionPrivilegeGet(companyId?: number, functionId?: number, privilegeCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserListByFunctionPrivilegeViewModel>>>;
    public rbacGetUserListByFunctionPrivilegeGet(companyId?: number, functionId?: number, privilegeCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('CompanyId', <any>companyId);
        }
        if (functionId !== undefined && functionId !== null) {
            queryParameters = queryParameters.set('FunctionId', <any>functionId);
        }
        if (privilegeCode !== undefined && privilegeCode !== null) {
            queryParameters = queryParameters.set('PrivilegeCode', <any>privilegeCode);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserListByFunctionPrivilegeViewModel>>('get',`${this.basePath}/Rbac/GetUserListByFunctionPrivilege`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 所有職稱
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JobTitlesViewModel>>;
    public rbacJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JobTitlesViewModel>>>;
    public rbacJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JobTitlesViewModel>>>;
    public rbacJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<JobTitlesViewModel>>('get',`${this.basePath}/Rbac/JobTitles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 資料權限
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacJointPrivilegeSearchPost(body?: SearchJointPrivilegeFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchPrivilegeUserNoViewModel>;
    public rbacJointPrivilegeSearchPost(body?: SearchJointPrivilegeFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeSearchPost(body?: SearchJointPrivilegeFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeSearchPost(body?: SearchJointPrivilegeFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchPrivilegeUserNoViewModel>('post',`${this.basePath}/Rbac/JointPrivilege/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢   指定 使用者、資料權限代碼 的資料權限 與  使用者 業務相關 的資料權限
     *
     * @param userNo 使用者代號
     * @param functionCode
     * @param privilegeCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet(userNo: string, functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchPrivilegeUserNoViewModel>;
    public rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet(userNo: string, functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet(userNo: string, functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet(userNo: string, functionCode: string, privilegeCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet.');
        }

        if (functionCode === null || functionCode === undefined) {
            throw new Error('Required parameter functionCode was null or undefined when calling rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet.');
        }

        if (privilegeCode === null || privilegeCode === undefined) {
            throw new Error('Required parameter privilegeCode was null or undefined when calling rbacJointPrivilegeUserNoFunctionCodePrivilegeCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchPrivilegeUserNoViewModel>('get',`${this.basePath}/Rbac/JointPrivilege/${encodeURIComponent(String(userNo))}/${encodeURIComponent(String(functionCode))}/${encodeURIComponent(String(privilegeCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢   指定 使用者、資料權限代碼 的資料權限 與  使用者 業務相關 的資料權限
     *
     * @param userNo 使用者代號
     * @param searchFunctionCode 功能代號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacJointPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchPrivilegeUserNoViewModel>;
    public rbacJointPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchPrivilegeUserNoViewModel>>;
    public rbacJointPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacJointPrivilegeUserNoSearchFunctionCodeGet.');
        }

        if (searchFunctionCode === null || searchFunctionCode === undefined) {
            throw new Error('Required parameter searchFunctionCode was null or undefined when calling rbacJointPrivilegeUserNoSearchFunctionCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchPrivilegeUserNoViewModel>('get',`${this.basePath}/Rbac/JointPrivilege/${encodeURIComponent(String(userNo))}/${encodeURIComponent(String(searchFunctionCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 驗證使用者是否有該API的操作權限(ServiceName)(代理人)
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionAPIBpmFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacPermissionAPIBpmFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacPermissionAPIBpmFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacPermissionAPIBpmFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/Permission/API/Bpm/FilterWithService`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 驗證使用者是否有該API的操作權限
     *
     * @param email 員工EMail
     * @param url URL
     * @param method 使用的HTTP Method
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionAPIFilterGet(email?: string, url?: string, method?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacPermissionAPIFilterGet(email?: string, url?: string, method?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacPermissionAPIFilterGet(email?: string, url?: string, method?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacPermissionAPIFilterGet(email?: string, url?: string, method?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (url !== undefined && url !== null) {
            queryParameters = queryParameters.set('url', <any>url);
        }
        if (method !== undefined && method !== null) {
            queryParameters = queryParameters.set('method', <any>method);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/Rbac/Permission/API/Filter`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 驗證使用者是否有該API的操作權限
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionAPIFilterPost(body?: PermissionAPIEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacPermissionAPIFilterPost(body?: PermissionAPIEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacPermissionAPIFilterPost(body?: PermissionAPIEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacPermissionAPIFilterPost(body?: PermissionAPIEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/Permission/API/Filter`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 驗證使用者是否有該API的操作權限(ServiceName)
     *
     * @param email 員工EMail
     * @param url URL
     * @param method 使用的HTTP Method
     * @param serviceName Knog service name
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionAPIFilterWithServiceGet(email?: string, url?: string, method?: string, serviceName?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacPermissionAPIFilterWithServiceGet(email?: string, url?: string, method?: string, serviceName?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacPermissionAPIFilterWithServiceGet(email?: string, url?: string, method?: string, serviceName?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacPermissionAPIFilterWithServiceGet(email?: string, url?: string, method?: string, serviceName?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (url !== undefined && url !== null) {
            queryParameters = queryParameters.set('url', <any>url);
        }
        if (method !== undefined && method !== null) {
            queryParameters = queryParameters.set('method', <any>method);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/Rbac/Permission/API/FilterWithService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 驗證使用者是否有該API的操作權限(ServiceName)
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionAPIFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacPermissionAPIFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacPermissionAPIFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacPermissionAPIFilterWithServicePost(body?: PermissionAPIEditModelWithService, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/Permission/API/FilterWithService`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得使用者的權限
     *
     * @param userNo 員工編號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacPermissionUserUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserPermissionViewModel>;
    public rbacPermissionUserUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserPermissionViewModel>>;
    public rbacPermissionUserUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserPermissionViewModel>>;
    public rbacPermissionUserUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacPermissionUserUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserPermissionViewModel>('get',`${this.basePath}/Rbac/Permission/User/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 搜尋 使用者代碼清單 之 流程角色資訊
     *
     * @param body 使用者代碼清單
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacProcessRoleIdsSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchProcessRoleIdsViewModel>;
    public rbacProcessRoleIdsSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchProcessRoleIdsViewModel>>;
    public rbacProcessRoleIdsSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchProcessRoleIdsViewModel>>;
    public rbacProcessRoleIdsSearchPost(body?: UserNoContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchProcessRoleIdsViewModel>('post',`${this.basePath}/Rbac/ProcessRole/Ids/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 流程角色 之 使用者
     *
     * @param processRoleId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacProcessRolesProcessRoleIdGet(processRoleId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<ProcessRolesUsersViewModel>;
    public rbacProcessRolesProcessRoleIdGet(processRoleId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessRolesUsersViewModel>>;
    public rbacProcessRolesProcessRoleIdGet(processRoleId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessRolesUsersViewModel>>;
    public rbacProcessRolesProcessRoleIdGet(processRoleId: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (processRoleId === null || processRoleId === undefined) {
            throw new Error('Required parameter processRoleId was null or undefined when calling rbacProcessRolesProcessRoleIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProcessRolesUsersViewModel>('get',`${this.basePath}/Rbac/ProcessRoles/${encodeURIComponent(String(processRoleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 統計 流程角色 之 使用者人數
     *
     * @param body 流程角色(ProcessRoleCode)陣列
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacProcessRolesUserCountPost(body?: ProcessRoleIdContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<CountProcessRolesUsersViewModel>;
    public rbacProcessRolesUserCountPost(body?: ProcessRoleIdContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CountProcessRolesUsersViewModel>>;
    public rbacProcessRolesUserCountPost(body?: ProcessRoleIdContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CountProcessRolesUsersViewModel>>;
    public rbacProcessRolesUserCountPost(body?: ProcessRoleIdContainer, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CountProcessRolesUsersViewModel>('post',`${this.basePath}/Rbac/ProcessRoles/User/Count`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 CompanyId 之 角色
     *
     * @param companyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleCompanyCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RoleViewModel>>;
    public rbacRoleCompanyCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RoleViewModel>>>;
    public rbacRoleCompanyCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RoleViewModel>>>;
    public rbacRoleCompanyCompanyIdGet(companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacRoleCompanyCompanyIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RoleViewModel>>('get',`${this.basePath}/Rbac/Role/Company/${encodeURIComponent(String(companyId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢角色已設定的部門人員屬性
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleDepartmentUserTypesSearchPost(body?: RoleDepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<RoleDepartmentUserTypeSearch>;
    public rbacRoleDepartmentUserTypesSearchPost(body?: RoleDepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDepartmentUserTypeSearch>>;
    public rbacRoleDepartmentUserTypesSearchPost(body?: RoleDepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDepartmentUserTypeSearch>>;
    public rbacRoleDepartmentUserTypesSearchPost(body?: RoleDepartmentUserTypeSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDepartmentUserTypeSearch>('post',`${this.basePath}/Rbac/RoleDepartmentUserTypes/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增角色資訊
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRolePost(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<RoleDataViewMode>;
    public rbacRolePost(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDataViewMode>>;
    public rbacRolePost(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDataViewMode>>;
    public rbacRolePost(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDataViewMode>('post',`${this.basePath}/Rbac/Role`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢角色已設定系統功能權限
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRolePrivilegeMappingSearchPost(body?: SearchRolePrivilegeMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchRolePrivilegeMappingViewModel>;
    public rbacRolePrivilegeMappingSearchPost(body?: SearchRolePrivilegeMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchRolePrivilegeMappingViewModel>>;
    public rbacRolePrivilegeMappingSearchPost(body?: SearchRolePrivilegeMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchRolePrivilegeMappingViewModel>>;
    public rbacRolePrivilegeMappingSearchPost(body?: SearchRolePrivilegeMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchRolePrivilegeMappingViewModel>('post',`${this.basePath}/Rbac/RolePrivilegeMapping/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 修改角色資訊
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRolePut(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacRolePut(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacRolePut(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacRolePut(body?: RoleDataViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/Role`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 RoleCode 之 角色
     *
     * @param roleCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<RoleViewModel>;
    public rbacRoleRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleViewModel>>;
    public rbacRoleRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleViewModel>>;
    public rbacRoleRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (roleCode === null || roleCode === undefined) {
            throw new Error('Required parameter roleCode was null or undefined when calling rbacRoleRoleCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RoleViewModel>('get',`${this.basePath}/Rbac/Role/${encodeURIComponent(String(roleCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 RoleId 之 角色
     *
     * @param roleId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleRoleIdRoleIdGet(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<RoleViewModel>;
    public rbacRoleRoleIdRoleIdGet(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleViewModel>>;
    public rbacRoleRoleIdRoleIdGet(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleViewModel>>;
    public rbacRoleRoleIdRoleIdGet(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling rbacRoleRoleIdRoleIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RoleViewModel>('get',`${this.basePath}/Rbac/Role/RoleId/${encodeURIComponent(String(roleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關角色資料權維護和資料權限維護-複製
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleSearchPrivilegeCopyPost(body?: SourceTargetRoleViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacRoleSearchPrivilegeCopyPost(body?: SourceTargetRoleViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacRoleSearchPrivilegeCopyPost(body?: SourceTargetRoleViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacRoleSearchPrivilegeCopyPost(body?: SourceTargetRoleViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/RoleSearchPrivilege/Copy`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關角色資料權維護和資料權限維護-新增/更新
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleSearchPrivilegePut(body?: RoleSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacRoleSearchPrivilegePut(body?: RoleSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacRoleSearchPrivilegePut(body?: RoleSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacRoleSearchPrivilegePut(body?: RoleSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/RoleSearchPrivilege`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關角色資料權維護和資料權限維護-刪除
     *
     * @param roleId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRoleSearchPrivilegeRoleRoleIdDelete(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacRoleSearchPrivilegeRoleRoleIdDelete(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacRoleSearchPrivilegeRoleRoleIdDelete(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacRoleSearchPrivilegeRoleRoleIdDelete(roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling rbacRoleSearchPrivilegeRoleRoleIdDelete.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Rbac/RoleSearchPrivilege/Role/${encodeURIComponent(String(roleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 刪除角色
     *
     * @param body 角色資料ID
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRolesDelete(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacRolesDelete(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacRolesDelete(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacRolesDelete(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/Rbac/Roles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢Role
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacRolesSearchPost(body?: SearchRoleConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchRoleViewModel>;
    public rbacRolesSearchPost(body?: SearchRoleConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchRoleViewModel>>;
    public rbacRolesSearchPost(body?: SearchRoleConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchRoleViewModel>>;
    public rbacRolesSearchPost(body?: SearchRoleConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchRoleViewModel>('post',`${this.basePath}/Rbac/Roles/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 刪除業審客法
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingDelete(body?: Array<SCCLMappingEditModel>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacSCCLMappingDelete(body?: Array<SCCLMappingEditModel>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacSCCLMappingDelete(body?: Array<SCCLMappingEditModel>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacSCCLMappingDelete(body?: Array<SCCLMappingEditModel>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('delete',`${this.basePath}/Rbac/SCCLMapping`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定部門 之 所有業務部門
     *
     * @param departmentId 部門代號
     * @param filterDisabled 過濾未使用部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingDepartmentDepartmentIdSalesDepartmentGet(departmentId: number, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentEditModel>>;
    public rbacSCCLMappingDepartmentDepartmentIdSalesDepartmentGet(departmentId: number, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentEditModel>>>;
    public rbacSCCLMappingDepartmentDepartmentIdSalesDepartmentGet(departmentId: number, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentEditModel>>>;
    public rbacSCCLMappingDepartmentDepartmentIdSalesDepartmentGet(departmentId: number, filterDisabled?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacSCCLMappingDepartmentDepartmentIdSalesDepartmentGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterDisabled !== undefined && filterDisabled !== null) {
            queryParameters = queryParameters.set('filterDisabled', <any>filterDisabled);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentEditModel>>('get',`${this.basePath}/Rbac/SCCLMapping/Department/${encodeURIComponent(String(departmentId))}/SalesDepartment`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢業審客法
     *
     * @param baclmappingId
     * @param mapSalesDeptId
     * @param mapCrdDeptId
     * @param mapCsDeptId
     * @param mapLawDeptId
     * @param updateTime
     * @param updateNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingGet(baclmappingId?: number, mapSalesDeptId?: number, mapCrdDeptId?: number, mapCsDeptId?: number, mapLawDeptId?: number, updateTime?: Date, updateNo?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SCCLMappingViewModel>>;
    public rbacSCCLMappingGet(baclmappingId?: number, mapSalesDeptId?: number, mapCrdDeptId?: number, mapCsDeptId?: number, mapLawDeptId?: number, updateTime?: Date, updateNo?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SCCLMappingViewModel>>>;
    public rbacSCCLMappingGet(baclmappingId?: number, mapSalesDeptId?: number, mapCrdDeptId?: number, mapCsDeptId?: number, mapLawDeptId?: number, updateTime?: Date, updateNo?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SCCLMappingViewModel>>>;
    public rbacSCCLMappingGet(baclmappingId?: number, mapSalesDeptId?: number, mapCrdDeptId?: number, mapCsDeptId?: number, mapLawDeptId?: number, updateTime?: Date, updateNo?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (baclmappingId !== undefined && baclmappingId !== null) {
            queryParameters = queryParameters.set('BaclmappingId', <any>baclmappingId);
        }
        if (mapSalesDeptId !== undefined && mapSalesDeptId !== null) {
            queryParameters = queryParameters.set('MapSalesDeptId', <any>mapSalesDeptId);
        }
        if (mapCrdDeptId !== undefined && mapCrdDeptId !== null) {
            queryParameters = queryParameters.set('MapCrdDeptId', <any>mapCrdDeptId);
        }
        if (mapCsDeptId !== undefined && mapCsDeptId !== null) {
            queryParameters = queryParameters.set('MapCsDeptId', <any>mapCsDeptId);
        }
        if (mapLawDeptId !== undefined && mapLawDeptId !== null) {
            queryParameters = queryParameters.set('MapLawDeptId', <any>mapLawDeptId);
        }
        if (updateTime !== undefined && updateTime !== null) {
            queryParameters = queryParameters.set('UpdateTime', <any>updateTime.toISOString());
        }
        if (updateNo !== undefined && updateNo !== null) {
            queryParameters = queryParameters.set('UpdateNo', <any>updateNo);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SCCLMappingViewModel>>('get',`${this.basePath}/Rbac/SCCLMapping`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定部門 之 對應業審客法 部門
     *
     * @param inWorkType
     * @param deptId
     * @param outWorkType
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet(inWorkType: number, deptId: number, outWorkType: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DepartmentEditModel>>;
    public rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet(inWorkType: number, deptId: number, outWorkType: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DepartmentEditModel>>>;
    public rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet(inWorkType: number, deptId: number, outWorkType: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DepartmentEditModel>>>;
    public rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet(inWorkType: number, deptId: number, outWorkType: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (inWorkType === null || inWorkType === undefined) {
            throw new Error('Required parameter inWorkType was null or undefined when calling rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet.');
        }

        if (deptId === null || deptId === undefined) {
            throw new Error('Required parameter deptId was null or undefined when calling rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet.');
        }

        if (outWorkType === null || outWorkType === undefined) {
            throw new Error('Required parameter outWorkType was null or undefined when calling rbacSCCLMappingInWorkTypeDeptIdOutWorkTypeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DepartmentEditModel>>('get',`${this.basePath}/Rbac/SCCLMapping/${encodeURIComponent(String(inWorkType))}/${encodeURIComponent(String(deptId))}/${encodeURIComponent(String(outWorkType))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增業審客法
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingPost(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSCCLMappingPost(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSCCLMappingPost(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSCCLMappingPost(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/SCCLMapping`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新業審客法
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSCCLMappingPut(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacSCCLMappingPut(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacSCCLMappingPut(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacSCCLMappingPut(body?: SCCLMappingEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('put',`${this.basePath}/Rbac/SCCLMapping`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 業助資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSalesSupportSearchPost(body?: SearchSalesSupportFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchSalesSupportViewModel>;
    public rbacSalesSupportSearchPost(body?: SearchSalesSupportFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchSalesSupportViewModel>>;
    public rbacSalesSupportSearchPost(body?: SearchSalesSupportFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchSalesSupportViewModel>>;
    public rbacSalesSupportSearchPost(body?: SearchSalesSupportFilterModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchSalesSupportViewModel>('post',`${this.basePath}/Rbac/SalesSupport/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 依 角色Id 查詢 部門
     *
     * @param companyId 公司代號
     * @param systemId 系統編號
     * @param roleId 角色代號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet(companyId: number, systemId: number, roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RoleSearchPrivilegeViewModel>>;
    public rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet(companyId: number, systemId: number, roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RoleSearchPrivilegeViewModel>>>;
    public rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet(companyId: number, systemId: number, roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RoleSearchPrivilegeViewModel>>>;
    public rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet(companyId: number, systemId: number, roleId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet.');
        }

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet.');
        }

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling rbacSearchPrivilegeCompanyCompanyIdSystemSystemIdRoleRoleIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RoleSearchPrivilegeViewModel>>('get',`${this.basePath}/Rbac/SearchPrivilege/Company/${encodeURIComponent(String(companyId))}/System/${encodeURIComponent(String(systemId))}/Role/${encodeURIComponent(String(roleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 依 人員編號 查詢 部門
     *
     * @param companyId 公司代號
     * @param userNo 人員編號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeCompanyIdDepartmentUserNoGet(companyId: number, userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SearchPrivilegeDepartmentViewModel>>;
    public rbacSearchPrivilegeCompanyIdDepartmentUserNoGet(companyId: number, userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SearchPrivilegeDepartmentViewModel>>>;
    public rbacSearchPrivilegeCompanyIdDepartmentUserNoGet(companyId: number, userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SearchPrivilegeDepartmentViewModel>>>;
    public rbacSearchPrivilegeCompanyIdDepartmentUserNoGet(companyId: number, userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacSearchPrivilegeCompanyIdDepartmentUserNoGet.');
        }

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSearchPrivilegeCompanyIdDepartmentUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SearchPrivilegeDepartmentViewModel>>('get',`${this.basePath}/Rbac/SearchPrivilege/${encodeURIComponent(String(companyId))}/Department/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關員工資料權維護和資料權限維護-複製
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeCopyPost(body?: SourceTargetUserViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSearchPrivilegeCopyPost(body?: SourceTargetUserViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSearchPrivilegeCopyPost(body?: SourceTargetUserViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSearchPrivilegeCopyPost(body?: SourceTargetUserViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/SearchPrivilege/Copy`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關員工資料權維護和資料權限維護-新增/更新
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegePut(body?: UserSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSearchPrivilegePut(body?: UserSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSearchPrivilegePut(body?: UserSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSearchPrivilegePut(body?: UserSearchPrivilegeEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/SearchPrivilege`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 相關員工資料權維護和資料權限維護-刪除
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeUserNoDelete(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSearchPrivilegeUserNoDelete(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSearchPrivilegeUserNoDelete(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSearchPrivilegeUserNoDelete(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSearchPrivilegeUserNoDelete.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Rbac/SearchPrivilege/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定員工 之 權限資料
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PrivilegeCodeInfoViewModel>>;
    public rbacSearchPrivilegeUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PrivilegeCodeInfoViewModel>>>;
    public rbacSearchPrivilegeUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PrivilegeCodeInfoViewModel>>>;
    public rbacSearchPrivilegeUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSearchPrivilegeUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PrivilegeCodeInfoViewModel>>('get',`${this.basePath}/Rbac/SearchPrivilege/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢指定 使用者 之 資料權限代碼 之 資料權限
     *
     * @param userNo
     * @param searchFunctionCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSearchPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchPrivilegeUserNoViewModel>;
    public rbacSearchPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchPrivilegeUserNoViewModel>>;
    public rbacSearchPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchPrivilegeUserNoViewModel>>;
    public rbacSearchPrivilegeUserNoSearchFunctionCodeGet(userNo: string, searchFunctionCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSearchPrivilegeUserNoSearchFunctionCodeGet.');
        }

        if (searchFunctionCode === null || searchFunctionCode === undefined) {
            throw new Error('Required parameter searchFunctionCode was null or undefined when calling rbacSearchPrivilegeUserNoSearchFunctionCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchPrivilegeUserNoViewModel>('get',`${this.basePath}/Rbac/SearchPrivilege/${encodeURIComponent(String(userNo))}/${encodeURIComponent(String(searchFunctionCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 依部門代號清單新增部門資料快照
     *
     * @param body 部門代號清單
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSnapShotDepartmentPost(body?: SnapShotDepartmentViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSnapShotDepartmentPost(body?: SnapShotDepartmentViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSnapShotDepartmentPost(body?: SnapShotDepartmentViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSnapShotDepartmentPost(body?: SnapShotDepartmentViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/SnapShot/Department`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 依員編代號清單新增人員資料快照
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSnapShotUserProfilePost(body?: SnapShotUserProfileViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSnapShotUserProfilePost(body?: SnapShotUserProfileViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSnapShotUserProfilePost(body?: SnapShotUserProfileViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSnapShotUserProfilePost(body?: SnapShotUserProfileViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/SnapShot/UserProfile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢指定 使用者 之 被代理資訊
     *
     * @param userNo
     * @param systemCode
     * @param functionCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSubstituteOfUserNoGet(userNo: string, systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SubstitutionViewModel>;
    public rbacSubstituteOfUserNoGet(userNo: string, systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubstitutionViewModel>>;
    public rbacSubstituteOfUserNoGet(userNo: string, systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubstitutionViewModel>>;
    public rbacSubstituteOfUserNoGet(userNo: string, systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSubstituteOfUserNoGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemCode !== undefined && systemCode !== null) {
            queryParameters = queryParameters.set('systemCode', <any>systemCode);
        }
        if (functionCode !== undefined && functionCode !== null) {
            queryParameters = queryParameters.set('functionCode', <any>functionCode);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubstitutionViewModel>('get',`${this.basePath}/Rbac/SubstituteOf/${encodeURIComponent(String(userNo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢指定 使用者 之 代理資訊
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSubstitutionsUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<PrincipalSubstitutionViewModel>;
    public rbacSubstitutionsUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrincipalSubstitutionViewModel>>;
    public rbacSubstitutionsUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrincipalSubstitutionViewModel>>;
    public rbacSubstitutionsUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacSubstitutionsUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PrincipalSubstitutionViewModel>('get',`${this.basePath}/Rbac/Substitutions/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢系統功能權限
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemFunctionPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchSystemFunctionPrivilegeViewModel>;
    public rbacSystemFunctionPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchSystemFunctionPrivilegeViewModel>>;
    public rbacSystemFunctionPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchSystemFunctionPrivilegeViewModel>>;
    public rbacSystemFunctionPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchSystemFunctionPrivilegeViewModel>('post',`${this.basePath}/Rbac/SystemFunctionPrivilege/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 SystemId 或 SystemFunctionId
     *
     * @param systemCode
     * @param functionCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemFunctionSearchGet(systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacSystemFunctionSearchGet(systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacSystemFunctionSearchGet(systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacSystemFunctionSearchGet(systemCode?: string, functionCode?: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemCode !== undefined && systemCode !== null) {
            queryParameters = queryParameters.set('SystemCode', <any>systemCode);
        }
        if (functionCode !== undefined && functionCode !== null) {
            queryParameters = queryParameters.set('FunctionCode', <any>functionCode);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/Rbac/SystemFunction/Search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 所有系統
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemViewModel>>;
    public rbacSystemGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemViewModel>>>;
    public rbacSystemGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemViewModel>>>;
    public rbacSystemGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemViewModel>>('get',`${this.basePath}/Rbac/System`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 所有系統群組
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemGroupGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemGroupViewModel>>;
    public rbacSystemGroupGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemGroupViewModel>>>;
    public rbacSystemGroupGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemGroupViewModel>>>;
    public rbacSystemGroupGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemGroupViewModel>>('get',`${this.basePath}/Rbac/SystemGroup`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 依 系統代碼 查詢 使用者資料(僅主檔)
     *
     * @param systemCode 系統代碼
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemPermissionSystemCodeSystemCodeUserProfileGet(systemCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserProfileMasterViewModel>>;
    public rbacSystemPermissionSystemCodeSystemCodeUserProfileGet(systemCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserProfileMasterViewModel>>>;
    public rbacSystemPermissionSystemCodeSystemCodeUserProfileGet(systemCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserProfileMasterViewModel>>>;
    public rbacSystemPermissionSystemCodeSystemCodeUserProfileGet(systemCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling rbacSystemPermissionSystemCodeSystemCodeUserProfileGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserProfileMasterViewModel>>('get',`${this.basePath}/Rbac/System/Permission/SystemCode/${encodeURIComponent(String(systemCode))}/UserProfile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定系統代號 之系統資訊
     *
     * @param systemId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemSystemIdGet(systemId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SystemViewModel>;
    public rbacSystemSystemIdGet(systemId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemViewModel>>;
    public rbacSystemSystemIdGet(systemId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemViewModel>>;
    public rbacSystemSystemIdGet(systemId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling rbacSystemSystemIdGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SystemViewModel>('get',`${this.basePath}/Rbac/System/${encodeURIComponent(String(systemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定系統代號 之系統資訊
     *
     * @param systemId
     * @param limitProcess
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacSystemSystemIdSystemFunctionGet(systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SystemViewModel>;
    public rbacSystemSystemIdSystemFunctionGet(systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemViewModel>>;
    public rbacSystemSystemIdSystemFunctionGet(systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemViewModel>>;
    public rbacSystemSystemIdSystemFunctionGet(systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling rbacSystemSystemIdSystemFunctionGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (limitProcess !== undefined && limitProcess !== null) {
            queryParameters = queryParameters.set('limitProcess', <any>limitProcess);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SystemViewModel>('get',`${this.basePath}/Rbac/System/${encodeURIComponent(String(systemId))}/SystemFunction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 所有 可使用的人員
     *
     * @param companyId 公司代號(選填)
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UsableUserProfileViewModel>>;
    public rbacUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UsableUserProfileViewModel>>>;
    public rbacUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UsableUserProfileViewModel>>>;
    public rbacUsableUserGet(companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UsableUserProfileViewModel>>('get',`${this.basePath}/Rbac/UsableUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢人員名稱對應表
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserDataMappingSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserDataMappingViewModel>>;
    public rbacUserDataMappingSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserDataMappingViewModel>>>;
    public rbacUserDataMappingSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserDataMappingViewModel>>>;
    public rbacUserDataMappingSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<UserDataMappingViewModel>>('post',`${this.basePath}/Rbac/UserDataMapping/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增人員、人員公司職稱、人員所在部門設定資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserDataProcessPost(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserDataProcessPost(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserDataProcessPost(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserDataProcessPost(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/UserDataProcess`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 修改人員、人員公司職稱、人員所在部門設定資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserDataProcessPut(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserDataProcessPut(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserDataProcessPut(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserDataProcessPut(body?: UserDataProcessViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/UserDataProcess`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢員工於各公司別職稱設定
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitleCompanySearchPost(body?: UserJobTitleCompanySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserJobTitleCompanySearch>;
    public rbacUserJobTitleCompanySearchPost(body?: UserJobTitleCompanySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserJobTitleCompanySearch>>;
    public rbacUserJobTitleCompanySearchPost(body?: UserJobTitleCompanySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserJobTitleCompanySearch>>;
    public rbacUserJobTitleCompanySearchPost(body?: UserJobTitleCompanySearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserJobTitleCompanySearch>('post',`${this.basePath}/Rbac/UserJobTitleCompany/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢 指定部門 之 指定職稱 之 所有使用者
     *
     * @param jobTitleId
     * @param departmentId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet(jobTitleId: number, departmentId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EmailNotificationModel>>;
    public rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet(jobTitleId: number, departmentId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EmailNotificationModel>>>;
    public rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet(jobTitleId: number, departmentId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EmailNotificationModel>>>;
    public rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet(jobTitleId: number, departmentId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (jobTitleId === null || jobTitleId === undefined) {
            throw new Error('Required parameter jobTitleId was null or undefined when calling rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet.');
        }

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacUserJobTitleDepartmentDepartmentIdJobTitleJobTitleIdUserProfileGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<EmailNotificationModel>>('get',`${this.basePath}/Rbac/UserJobTitle/Department/${encodeURIComponent(String(departmentId))}/JobTitle/${encodeURIComponent(String(jobTitleId))}/UserProfile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢角色已設定職稱
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitleRoleMappingSearchPost(body?: SearchUserJobTitleRoleMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchUserJobTitleRoleMappingViewModel>;
    public rbacUserJobTitleRoleMappingSearchPost(body?: SearchUserJobTitleRoleMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchUserJobTitleRoleMappingViewModel>>;
    public rbacUserJobTitleRoleMappingSearchPost(body?: SearchUserJobTitleRoleMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchUserJobTitleRoleMappingViewModel>>;
    public rbacUserJobTitleRoleMappingSearchPost(body?: SearchUserJobTitleRoleMappingConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchUserJobTitleRoleMappingViewModel>('post',`${this.basePath}/Rbac/UserJobTitleRoleMapping/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢已設定的角色
     *
     * @param roleId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitleRoleUserMappingSearchGet(roleId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserJobTitlesSearchInfoViewMode>>;
    public rbacUserJobTitleRoleUserMappingSearchGet(roleId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserJobTitlesSearchInfoViewMode>>>;
    public rbacUserJobTitleRoleUserMappingSearchGet(roleId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserJobTitlesSearchInfoViewMode>>>;
    public rbacUserJobTitleRoleUserMappingSearchGet(roleId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roleId !== undefined && roleId !== null) {
            queryParameters = queryParameters.set('roleId', <any>roleId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserJobTitlesSearchInfoViewMode>>('get',`${this.basePath}/Rbac/UserJobTitleRoleUserMapping/Search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得所有職稱
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserJobTitleInfoViewModel>>;
    public rbacUserJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserJobTitleInfoViewModel>>>;
    public rbacUserJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserJobTitleInfoViewModel>>>;
    public rbacUserJobTitlesGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserJobTitleInfoViewModel>>('get',`${this.basePath}/Rbac/UserJobTitles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢員工職稱資訊
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserJobTitlesSearchPost(body?: UserJobTitlesSearchViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserJobTitlesSearchInfoViewMode>>;
    public rbacUserJobTitlesSearchPost(body?: UserJobTitlesSearchViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserJobTitlesSearchInfoViewMode>>>;
    public rbacUserJobTitlesSearchPost(body?: UserJobTitlesSearchViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserJobTitlesSearchInfoViewMode>>>;
    public rbacUserJobTitlesSearchPost(body?: UserJobTitlesSearchViewMode, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<UserJobTitlesSearchInfoViewMode>>('post',`${this.basePath}/Rbac/UserJobTitles/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得所屬人員批核主管清單
     *
     * @param userNo 使用者代號
     * @param filterVirtual 過濾虛擬部門
     * @param filterDisable 過濾停用部門
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileApprovedMgrListUserNoGet(userNo: string, filterVirtual?: boolean, filterDisable?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ApprovedMgrViewModel>>;
    public rbacUserProfileApprovedMgrListUserNoGet(userNo: string, filterVirtual?: boolean, filterDisable?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApprovedMgrViewModel>>>;
    public rbacUserProfileApprovedMgrListUserNoGet(userNo: string, filterVirtual?: boolean, filterDisable?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApprovedMgrViewModel>>>;
    public rbacUserProfileApprovedMgrListUserNoGet(userNo: string, filterVirtual?: boolean, filterDisable?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileApprovedMgrListUserNoGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterVirtual !== undefined && filterVirtual !== null) {
            queryParameters = queryParameters.set('filterVirtual', <any>filterVirtual);
        }
        if (filterDisable !== undefined && filterDisable !== null) {
            queryParameters = queryParameters.set('filterDisable', <any>filterDisable);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ApprovedMgrViewModel>>('get',`${this.basePath}/Rbac/UserProfile/ApprovedMgrList/${encodeURIComponent(String(userNo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定部門 或包含 所有下屬部門 之 所有用戶
     *
     * @param departmentId
     * @param isSub
     * @param filterSalesSupport
     * @param filterMultipleRole
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileDepartmentAllDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterSalesSupport?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserDepartmentViewMadel>>;
    public rbacUserProfileDepartmentAllDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterSalesSupport?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserDepartmentViewMadel>>>;
    public rbacUserProfileDepartmentAllDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterSalesSupport?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserDepartmentViewMadel>>>;
    public rbacUserProfileDepartmentAllDepartmentIdIsSubGet(departmentId: number, isSub: boolean, filterSalesSupport?: boolean, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacUserProfileDepartmentAllDepartmentIdIsSubGet.');
        }

        if (isSub === null || isSub === undefined) {
            throw new Error('Required parameter isSub was null or undefined when calling rbacUserProfileDepartmentAllDepartmentIdIsSubGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterSalesSupport !== undefined && filterSalesSupport !== null) {
            queryParameters = queryParameters.set('filterSalesSupport', <any>filterSalesSupport);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserDepartmentViewMadel>>('get',`${this.basePath}/Rbac/UserProfile/Department/All/${encodeURIComponent(String(departmentId))}/${encodeURIComponent(String(isSub))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定部門 或包含 所有下屬部門 之 所有用戶(主職)
     *
     * @param departmentId
     * @param isSub
     * @param includeDisabled
     * @param filterSalesSupport
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, includeDisabled?: boolean, filterSalesSupport?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserProfileEditModel>>;
    public rbacUserProfileDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, includeDisabled?: boolean, filterSalesSupport?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserProfileEditModel>>>;
    public rbacUserProfileDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, includeDisabled?: boolean, filterSalesSupport?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserProfileEditModel>>>;
    public rbacUserProfileDepartmentDepartmentIdIsSubGet(departmentId: number, isSub: boolean, includeDisabled?: boolean, filterSalesSupport?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling rbacUserProfileDepartmentDepartmentIdIsSubGet.');
        }

        if (isSub === null || isSub === undefined) {
            throw new Error('Required parameter isSub was null or undefined when calling rbacUserProfileDepartmentDepartmentIdIsSubGet.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeDisabled !== undefined && includeDisabled !== null) {
            queryParameters = queryParameters.set('includeDisabled', <any>includeDisabled);
        }
        if (filterSalesSupport !== undefined && filterSalesSupport !== null) {
            queryParameters = queryParameters.set('filterSalesSupport', <any>filterSalesSupport);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserProfileEditModel>>('get',`${this.basePath}/Rbac/UserProfile/Department/${encodeURIComponent(String(departmentId))}/${encodeURIComponent(String(isSub))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 使用者郵件 之 使用者
     *
     * @param emailAddress
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileEmailAddressEmailAddressGet(emailAddress: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserProfileViewModel>;
    public rbacUserProfileEmailAddressEmailAddressGet(emailAddress: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserProfileViewModel>>;
    public rbacUserProfileEmailAddressEmailAddressGet(emailAddress: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserProfileViewModel>>;
    public rbacUserProfileEmailAddressEmailAddressGet(emailAddress: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (emailAddress === null || emailAddress === undefined) {
            throw new Error('Required parameter emailAddress was null or undefined when calling rbacUserProfileEmailAddressEmailAddressGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserProfileViewModel>('get',`${this.basePath}/Rbac/UserProfile/EmailAddress/${encodeURIComponent(String(emailAddress))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 建立 用戶
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfilePost(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserProfilePost(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserProfilePost(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserProfilePost(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/UserProfile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 用戶
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfilePut(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserProfilePut(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserProfilePut(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserProfilePut(body?: UserProfileEditModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/UserProfile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定程序角色 之 所有用戶
     *
     * @param roleCode
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileRoleRoleCodeRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserProfileEditModel>>;
    public rbacUserProfileRoleRoleCodeRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserProfileEditModel>>>;
    public rbacUserProfileRoleRoleCodeRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserProfileEditModel>>>;
    public rbacUserProfileRoleRoleCodeRoleCodeGet(roleCode: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (roleCode === null || roleCode === undefined) {
            throw new Error('Required parameter roleCode was null or undefined when calling rbacUserProfileRoleRoleCodeRoleCodeGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserProfileEditModel>>('get',`${this.basePath}/Rbac/UserProfile/Role/RoleCode/${encodeURIComponent(String(roleCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢人員基本資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileSearchPost(body?: UserProfileSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserProfileSearch>;
    public rbacUserProfileSearchPost(body?: UserProfileSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserProfileSearch>>;
    public rbacUserProfileSearchPost(body?: UserProfileSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserProfileSearch>>;
    public rbacUserProfileSearchPost(body?: UserProfileSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserProfileSearch>('post',`${this.basePath}/Rbac/UserProfile/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 使用者代號 之 使用者
     *
     * @param userNo
     * @param filterVirtual
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoGet(userNo: string, filterVirtual?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserProfileViewModel>;
    public rbacUserProfileUserNoGet(userNo: string, filterVirtual?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserProfileViewModel>>;
    public rbacUserProfileUserNoGet(userNo: string, filterVirtual?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserProfileViewModel>>;
    public rbacUserProfileUserNoGet(userNo: string, filterVirtual?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterVirtual !== undefined && filterVirtual !== null) {
            queryParameters = queryParameters.set('filterVirtual', <any>filterVirtual);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserProfileViewModel>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定使用者 之 選單資料
     *
     * @param userNo
     * @param filterMultipleRole
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoMenuTreeGet(userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MenuTreeViewModel>>;
    public rbacUserProfileUserNoMenuTreeGet(userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MenuTreeViewModel>>>;
    public rbacUserProfileUserNoMenuTreeGet(userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MenuTreeViewModel>>>;
    public rbacUserProfileUserNoMenuTreeGet(userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoMenuTreeGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MenuTreeViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/MenuTree`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 搜尋 使用者代碼清單 之 使用者資訊
     *
     * @param body 員工代碼陣列
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserInfoViewModel>>;
    public rbacUserProfileUserNoSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserInfoViewModel>>>;
    public rbacUserProfileUserNoSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserInfoViewModel>>>;
    public rbacUserProfileUserNoSearchPost(body?: Array<string>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<UserInfoViewModel>>('post',`${this.basePath}/Rbac/UserProfile/UserNo/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定使用者 之 系統群組資料
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoSystemGroupGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemGroupViewModel>>;
    public rbacUserProfileUserNoSystemGroupGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemGroupViewModel>>>;
    public rbacUserProfileUserNoSystemGroupGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemGroupViewModel>>>;
    public rbacUserProfileUserNoSystemGroupGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoSystemGroupGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemGroupViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/SystemGroup`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定使用者 之 系統群組資料 之 選單資料
     *
     * @param systemGroupCode
     * @param userNo
     * @param filterMultipleRole
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet(systemGroupCode: string, userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MenuTreeViewModel>>;
    public rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet(systemGroupCode: string, userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MenuTreeViewModel>>>;
    public rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet(systemGroupCode: string, userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MenuTreeViewModel>>>;
    public rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet(systemGroupCode: string, userNo: string, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (systemGroupCode === null || systemGroupCode === undefined) {
            throw new Error('Required parameter systemGroupCode was null or undefined when calling rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet.');
        }

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoSystemGroupSystemGroupCodeMenuTreeGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MenuTreeViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/SystemGroup/${encodeURIComponent(String(systemGroupCode))}/MenuTree`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 指定業務類別 之 所有人員
     *
     * @param workType 業務類別
     * @param companyId 公司代號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileWorkTypeWorkTypeGet(workType: number, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserProfilebyWorkTypeViewModel>>;
    public rbacUserProfileWorkTypeWorkTypeGet(workType: number, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserProfilebyWorkTypeViewModel>>>;
    public rbacUserProfileWorkTypeWorkTypeGet(workType: number, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserProfilebyWorkTypeViewModel>>>;
    public rbacUserProfileWorkTypeWorkTypeGet(workType: number, companyId?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (workType === null || workType === undefined) {
            throw new Error('Required parameter workType was null or undefined when calling rbacUserProfileWorkTypeWorkTypeGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyId !== undefined && companyId !== null) {
            queryParameters = queryParameters.set('companyId', <any>companyId);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserProfilebyWorkTypeViewModel>>('get',`${this.basePath}/Rbac/UserProfile/WorkType/${encodeURIComponent(String(workType))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 撤銷 離職申請
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param updateUserNo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacUserResignCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacUserResignCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacUserResignCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (updateUserNo !== undefined && updateUserNo !== null) {
            queryParameters = queryParameters.set('updateUserNo', <any>updateUserNo);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('put',`${this.basePath}/Rbac/UserResignCancel`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得使用者離職執行列表設定檔
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignExecuteApiSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserResignExecuteApiSettingViewModel>>;
    public rbacUserResignExecuteApiSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserResignExecuteApiSettingViewModel>>>;
    public rbacUserResignExecuteApiSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserResignExecuteApiSettingViewModel>>>;
    public rbacUserResignExecuteApiSettingGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserResignExecuteApiSettingViewModel>>('get',`${this.basePath}/Rbac/UserResignExecuteApiSetting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增離職執行列表
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignExecuteRecordPost(body?: UserResignExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserResignExecuteRecordPost(body?: UserResignExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserResignExecuteRecordPost(body?: UserResignExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserResignExecuteRecordPost(body?: UserResignExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/UserResignExecuteRecord`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得使用者離職執行列表
     *
     * @param userNo 使用者編號
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignExecuteRecordUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserResignExecuteRecordViewModel>>;
    public rbacUserResignExecuteRecordUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserResignExecuteRecordViewModel>>>;
    public rbacUserResignExecuteRecordUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserResignExecuteRecordViewModel>>>;
    public rbacUserResignExecuteRecordUserNoGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserResignExecuteRecordUserNoGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserResignExecuteRecordViewModel>>('get',`${this.basePath}/Rbac/UserResignExecuteRecord/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 執行離職更新
     *
     * @param userNo
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignExecuteUserNoPut(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserResignExecuteUserNoPut(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserResignExecuteUserNoPut(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserResignExecuteUserNoPut(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserResignExecuteUserNoPut.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/Rbac/UserResignExecute/${encodeURIComponent(String(userNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 新增離職人員設定檔
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignPost(body?: UserResignApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserResignPost(body?: UserResignApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserResignPost(body?: UserResignApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserResignPost(body?: UserResignApplyViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/UserResign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢離職人員資料 - For排程
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignSearchJobGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserResignApplyInfoViewModel>>;
    public rbacUserResignSearchJobGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserResignApplyInfoViewModel>>>;
    public rbacUserResignSearchJobGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserResignApplyInfoViewModel>>>;
    public rbacUserResignSearchJobGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserResignApplyInfoViewModel>>('get',`${this.basePath}/Rbac/UserResign/SearchJob`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢離職人員資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserResignSearchPost(body?: UserResignSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<UserResignSearch>;
    public rbacUserResignSearchPost(body?: UserResignSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserResignSearch>>;
    public rbacUserResignSearchPost(body?: UserResignSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserResignSearch>>;
    public rbacUserResignSearchPost(body?: UserResignSearchViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserResignSearch>('post',`${this.basePath}/Rbac/UserResign/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 查詢特殊功能權限清單
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserSearchPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchSystemFunctionPrivilegeViewModel>;
    public rbacUserSearchPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchSystemFunctionPrivilegeViewModel>>;
    public rbacUserSearchPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchSystemFunctionPrivilegeViewModel>>;
    public rbacUserSearchPrivilegeSearchPost(body?: SearchSystemFunctionPrivilegeConditionViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SearchSystemFunctionPrivilegeViewModel>('post',`${this.basePath}/Rbac/UserSearchPrivilege/Search`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 撤銷 調職申請
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param updateUserNo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserTransferCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacUserTransferCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacUserTransferCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacUserTransferCancelPut(body?: Array<number>, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, updateUserNo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (updateUserNo !== undefined && updateUserNo !== null) {
            queryParameters = queryParameters.set('updateUserNo', <any>updateUserNo);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('put',`${this.basePath}/Rbac/UserTransferCancel`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢 調職資料
     *
     * @param userNo
     * @param isExecute
     * @param transferDateS
     * @param transferDateE
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserTransferExecuteRecordGet(userNo?: string, isExecute?: boolean, transferDateS?: Date, transferDateE?: Date, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserTransferSearch>>;
    public rbacUserTransferExecuteRecordGet(userNo?: string, isExecute?: boolean, transferDateS?: Date, transferDateE?: Date, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserTransferSearch>>>;
    public rbacUserTransferExecuteRecordGet(userNo?: string, isExecute?: boolean, transferDateS?: Date, transferDateE?: Date, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserTransferSearch>>>;
    public rbacUserTransferExecuteRecordGet(userNo?: string, isExecute?: boolean, transferDateS?: Date, transferDateE?: Date, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userNo !== undefined && userNo !== null) {
            queryParameters = queryParameters.set('userNo', <any>userNo);
        }
        if (isExecute !== undefined && isExecute !== null) {
            queryParameters = queryParameters.set('isExecute', <any>isExecute);
        }
        if (transferDateS !== undefined && transferDateS !== null) {
            queryParameters = queryParameters.set('transferDateS', <any>transferDateS.toISOString());
        }
        if (transferDateE !== undefined && transferDateE !== null) {
            queryParameters = queryParameters.set('transferDateE', <any>transferDateE.toISOString());
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserTransferSearch>>('get',`${this.basePath}/Rbac/UserTransferExecuteRecord`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 新增 調職紀錄
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserTransferExecuteRecordPost(body?: UserTransferExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacUserTransferExecuteRecordPost(body?: UserTransferExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacUserTransferExecuteRecordPost(body?: UserTransferExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacUserTransferExecuteRecordPost(body?: UserTransferExecuteRecordViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/Rbac/UserTransferExecuteRecord`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 更新 調職狀態
     *
     * @param userTransferApplyId
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserTransferExecuteUserTransferApplyIdPut(userTransferApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public rbacUserTransferExecuteUserTransferApplyIdPut(userTransferApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public rbacUserTransferExecuteUserTransferApplyIdPut(userTransferApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public rbacUserTransferExecuteUserTransferApplyIdPut(userTransferApplyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userTransferApplyId === null || userTransferApplyId === undefined) {
            throw new Error('Required parameter userTransferApplyId was null or undefined when calling rbacUserTransferExecuteUserTransferApplyIdPut.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('put',`${this.basePath}/Rbac/UserTransferExecute/${encodeURIComponent(String(userTransferApplyId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 新增 調職資料
     *
     * @param body
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserTransferPost(body?: UserTransferViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacUserTransferPost(body?: UserTransferViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacUserTransferPost(body?: UserTransferViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacUserTransferPost(body?: UserTransferViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Rbac/UserTransfer`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得所有工作地區
     *
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacWorkLocationsGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<WorkLocationsViewModel>>;
    public rbacWorkLocationsGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WorkLocationsViewModel>>>;
    public rbacWorkLocationsGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WorkLocationsViewModel>>>;
    public rbacWorkLocationsGet(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<WorkLocationsViewModel>>('get',`${this.basePath}/Rbac/WorkLocations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * [Public] 新增紀錄Log
    * 
    * @param body 
    * @param xFromChannel From Channel (Example: Web、APP...)
    * @param xClientTraceId Client side UUID
    * @param xServerTraceId Server side UUID
    * @param xClientDate Request time
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public rbacActionRecordPost(body?: ActionRecordBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public rbacActionRecordPost(body?: ActionRecordBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public rbacActionRecordPost(body?: ActionRecordBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public rbacActionRecordPost(body?: ActionRecordBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post', `${this.basePath}/Rbac/Action/Record`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
